import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import MyBecoming from "@/components/sections/MyBecoming";
import HowItFlows from "@/components/sections/HowItFlows";
import Frameworks from "@/components/sections/Frameworks";
import Offerings from "@/components/sections/Offerings";
import Harmonia from "@/components/sections/Harmonia";
import Testimonials from "@/components/sections/Testimonials";
import Reflections from "@/components/sections/Reflections";
import LetsConnect from "@/components/sections/LetsConnect";

export default function Landing() {
  return (
    <div className="bg-bone text-charcoal min-h-screen">
      <Nav />
      <main>
        <Hero />
        <MyBecoming />
        <HowItFlows />
        <Frameworks />
        <Offerings />
        <Harmonia />
        <Testimonials />
        <Reflections />
        <LetsConnect />
      </main>
      <Footer />
    </div>
  );
}
